import { render, staticRenderFns } from "./showResult.vue?vue&type=template&id=45e0df87&"
import script from "./showResult.vue?vue&type=script&lang=js&"
export * from "./showResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports